import React from "react";
import "./NavBart.css";
import logo from "../../media/logo.svg";
import menu from "../../media/bars-solid.svg"
import {hideMenu, showMenu} from "../../Helpers/Actions";

export default class NavBar extends React.Component{
    render() {
        return (
            <nav>
                <div className="container">
                    <div className="direccion">
                        <span>55 5719 2238 | Norte 15 4902, Magdalena de las Salinas, Ciudad de México</span>
                    </div>
                    <div className="menu">
                        <a href="/">
                            <img src={logo} alt=""/>
                        </a>
                        <div className="menu-container">
                            <div className="close" onClick={hideMenu}>X</div>
                            <a href="/">
                                Inicio
                            </a>
                            <a href="/servicios">
                                Servicios
                            </a>
                            {/*<a href="/productos">*/}
                            {/*    Productos*/}
                            {/*</a>*/}
                            <a href="tu_pedido">
                                Tu pedido
                            </a>
                            <a href="contacto">
                                Contacto
                            </a>
                        </div>
                        <div className="mobile-menu" onClick={showMenu}>
                            <img src={menu} alt=""/>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}